const today = new Date();

const roundCorrectInstance = (num, _) =>
  num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

function roundCorrect(value) {
  return parseFloat(roundCorrectInstance(value));
}

export function getDisplayPriceLevel1(item, customerGroup, includeBox, net) {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(getPriceLevel1(item, customerGroup, includeBox, net));
}

export function getPriceLevel1(item, customerGroup, includeBox, net) {
  var price = 0;
  item.products.forEach(product => {
    if (product.type === 'product' || (product.type === 'box' && includeBox)) {
      var times = 1;
      if ('quantity' in product) {
        times = product.quantity;
      }
      if (product.replaced) {
        price +=
          calculatePrice(
            net ? product.replaceData.originalPriceNet : product.replaceData.originalPrice,
            product.replaceData.price,
            customerGroup,
            net,
            product.replaceData.tax
          ) * times;
      } else {
        price +=
          calculatePrice(
            net ? product.originalPriceNet : product.originalPrice,
            product.price,
            customerGroup,
            net,
            product.tax
          ) * times;
      }
    }
  });
  return roundCorrect(price);
}

export function getDisplayPriceBox(item, customerGroup, net) {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(getPriceBox(item, customerGroup, net));
}

export function getPriceBox(item, customerGroup, net) {
  var price = 0;
  item.products.forEach(product => {
    if (product.type === 'box') {
      price += calculatePrice(
        net ? product.originalPriceNet : product.originalPrice,
        product.price,
        customerGroup,
        net,
        product.tax
      );
    }
  });

  return roundCorrect(price);
}

export function calculatePrice(
  defaultPrice,
  specialPrices,
  customerGroup,
  net,
  tax
) {
  if (customerGroup in specialPrices) {
    if (customerGroup === '2571' && !net) {
      return roundCorrect(specialPrices[customerGroup] * (1 + tax / 100));
    }
    if (net && customerGroup.toString() === '22832') {
      return roundCorrect(specialPrices[customerGroup] / (1 + tax / 100));
    }
    return roundCorrect(specialPrices[customerGroup]);
  }
  if (!net && 'default' in specialPrices) {
    return roundCorrect(specialPrices.default);
  }
  if (net && 'default_net' in specialPrices) {
    return roundCorrect(specialPrices.default_net);
  }

  return roundCorrect(defaultPrice);
}

export function getElementHeight(el) {
  if (el instanceof Element) {
    const computedStyle = window.getComputedStyle(el);

    return (
      Number(computedStyle.marginTop.replace(/[^0-9.]/g, '')) +
      Number(computedStyle.marginBottom.replace(/[^0-9.]/g, '')) +
      Number(el.offsetHeight)
    );
  }

  return 0;
}

export function getDisplayPriceLevel3(item, customerGroup, net) {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(getPriceLevel3(item, customerGroup, net));
}

export function getPriceLevel3(item, customerGroup, net) {
  if (item.price) {
    if (customerGroup in item.price) {
      return roundCorrect(item.price[customerGroup]);
    }
    if (!net && 'default' in item.price) {
      return roundCorrect(item.price.default);
    }
    if (net && 'default_net' in item.price) {
      return roundCorrect(item.price.default_net);
    }
    if (!net) {
      return roundCorrect(item.originalPrice);
    }
    if (net) {
      return roundCorrect(item.originalPriceNet);
    }
  } else {
    return 0;
  }
}

export function getDisplayPriceBoxLevel3(item, customerGroup, net) {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(getBoxPrice(item, customerGroup, net));
}

export function getBoxPrice(item, customerGroup, net) {
  if (item === undefined || item.price === undefined) {
    return 0;
  }
  if (customerGroup in item.price) {
    return roundCorrect(item.price[customerGroup]);
  }
  if (!net && 'default' in item.price) {
    return roundCorrect(item.price.default);
  }
  if (net && 'default_net' in item.price) {
    return roundCorrect(item.price.default_net);
  }
  if (!net) {
    return roundCorrect(item.originalPrice);
  }
  if (net) {
    return roundCorrect(item.originalPriceNet);
  }
}

export function boxContentListScrolled() {
  const scrollHint = document.getElementsByClassName(
    'box-content__scroll-hint'
  )[0];
  const boxContentList = document.getElementsByClassName(
    'box-content__list'
  )[0];
  if (boxContentList.scrollTop > 0) {
    scrollHint.classList.add('--has-scrolled');
  } else {
    scrollHint.classList.remove('--has-scrolled');
  }
}

export function calculateDeliveryTimeForProduct(product, qty, settings) {
  const productDate = new Date(product.release_date);
  if (productDate > today) {
    return Math.floor((productDate - today) / (1000 * 60 * 60 * 24) / 1.4);
  }

  var time = 0;

  var alreadyAdded = false;
  if (typeof (settings) !== 'undefined' && settings.length > 0) {
    settings.forEach(entry => {
      if (entry.min <= qty && !alreadyAdded) {
        if (typeof (product.prepackaged) !== 'undefined' && qty <= product.prepackaged.qty) {
          time += entry.value_lvl1;
        } else {
          time += entry.value_lvl3;
        }
        alreadyAdded = true;
      }
    });
  }

  if (product.fut_days > 0) {
    return time + product.fut_days;
  }

  var addThreshold = 0;
  var multiplier = 1;
  if ('quantity' in product) {
    multiplier = product.quantity;
  }

  if (
    product.stock_quantity + (product.custom_delivery_qty ? product.custom_delivery_qty.threshold_1 : 0) <
      qty * multiplier &&
      (product.custom_delivery_qty ? product.custom_delivery_qty.threshold_1_time : 0) > addThreshold
  ) {
    addThreshold = (product.custom_delivery_qty ? product.custom_delivery_qty.threshold_1_time : 0);
  } else if (product.stock_quantity < qty * multiplier) {
    if (product.delivery_time !== null) {
      const numbers = product.delivery_time.split('-');
      if (numbers.length === 1) {
        addThreshold = parseInt(numbers[0]);
      } else if (numbers.length === 3) {
        addThreshold = parseInt(numbers[1]);
      } else if (numbers.length === 4) {
        addThreshold = (parseInt(numbers[1]) + parseInt(numbers[2])) / 2;
      }
    }
  }

  time += addThreshold;
  return time;
}
